var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCeoLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.6484 19.5943C38.6484 30.1403 30.1081 38.6886 19.5742 38.6886C9.0403 38.6886 0.5 30.1403 0.5 19.5943C0.5 9.04832 9.0403 0.5 19.5742 0.5C30.1081 0.5 38.6484 9.04832 38.6484 19.5943Z",
    fill: "#1B1D21",
    stroke: "#1CD490"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.677 26.9424H12.5452V15.003H15.677V26.9424ZM14.1111 13.6267C13.1026 13.6267 12.2842 12.7692 12.2842 11.712C12.2842 10.6548 13.1026 9.79736 14.1111 9.79736C15.1196 9.79736 15.938 10.6548 15.938 11.712C15.938 12.7692 15.1206 13.6267 14.1111 13.6267ZM28.2045 26.9424H25.0727V20.8598C25.0727 17.2041 20.8968 17.4809 20.8968 20.8598V26.9424H17.765V15.003H20.8968V16.9187C22.3542 14.1118 28.2045 13.9045 28.2045 19.6061V26.9424Z",
    fill: "#1CD490"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCeoLinkedin);
export default __webpack_public_path__ + "static/media/CeoLinkedin.2dc1dff80056f4e4da5f7155cf1fe18b.svg";
export { ForwardRef as ReactComponent };